import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

function LegalPrivacy() {
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>Legal & Compliance Centre</h1>
          <p>
            Review ClubLoop's official Terms of Service, Privacy Policy, Shipping Frameworks, and Protected Escrow Refund Policies.
          </p>
        </div>

        <div className="infoSection">
          <nav className="legalNav" aria-label="Legal sections" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
            <a href="#terms">Terms of Service</a>
            <a href="#privacy">Privacy Policy</a>
            <a href="#refunds">Refund & Exchange Policy</a>
            <a href="#shipping">Shipping Policy</a>
          </nav>
        </div>

        {/* --- 1. TERMS OF SERVICE --- */}
        <div id="terms" className="infoSection">
          <h2>Terms of Service</h2>
          <p>
            By accessing or using the ClubLoop platform, website, or services, you accept and agree to be bound by the terms and provisions of this agreement.
          </p>
          <h3>1. Use License & Service Venue</h3>
          <p>
            ClubLoop provides an online marketplace specialized for pre-owned golf equipment. Permission is granted to temporarily view materials on this website for personal, non-commercial transitory viewing only. You must be at least 18 years of age to host active listing accounts or process transaction checks.
          </p>
          <h3>2. Core Transaction Channels</h3>
          <p>
            Our platform operates two distinct business tracks: Channel 1 (ClubLoop Stock), where ClubLoop acts as the direct merchant provider, and Channel 2 (Peer-to-Peer Marketplace), where ClubLoop sits in the middle as an escrow agent holding buyer funds for up to 5 days while transit and gear condition are validated by the recipient.
          </p>
          <h3>3. Disclaimer & Limitations</h3>
          <p>
            Materials on this website are provided on an "as is" basis. ClubLoop disclaims all other warranties including, without limitation, implied warranties or conditions of merchantability or fitness for a particular purpose. In no event shall ClubLoop or its suppliers be liable for any damages arising out of the use or inability to use materials on this platform.
          </p>
        </div>

        {/* --- 2. PRIVACY POLICY --- */}
        <div id="privacy" className="infoSection">
          <h2>Privacy Policy</h2>
          <p><strong>Effective Date: 01/03/2025</strong></p>
          <p>
            ClubLoop is committed to protecting the privacy and security of your personal information. By using our website, you agree to the collection, usage, and data sharing clauses outlined below.
          </p>
          <h3>Information We Collect</h3>
          <p>
            <strong>Personal Data:</strong> Name, email address, phone number, shipping/billing addresses, and payout credentials (UPI IDs or bank details). Financial transactions are processed strictly via secure integrated third-party payment gateway widgets (Razorpay).<br />
            <strong>Non-Personal Data:</strong> Browser variants, IP addresses, cookies, and operational site usage statistics.
          </p>
          <h3>How We Use Your Information</h3>
          <p>
            To fulfill orders, administer peer-to-peer escrow verification loops, execute automated transactional alerts via our WhatsApp Business API, track safety concerns, prevent platform fraud, and satisfy Indian legal compliance parameters.
          </p>
          <h3>Information Sharing & Security</h3>
          <p>
            We do not sell or rent user data. Data is shared only with integrated logistics partners (Delhivery, Blue Dart, DTDC) and secure payment processors. We implement SSL encryption protocols alongside rigorous access controls to block unauthorized disclosures.
          </p>
          <h3>Grievance Officer (Privacy & Data Protection)</h3>
          <p>
            In accordance with Indian Information Technology laws, any data complaints can be directly addressed to:<br />
            <strong>Grievance Officer:</strong> Lokesh Lakshman<br />
            <strong>Email:</strong> help@clubloop.in<br />
            <strong>Address:</strong> No – 102/3, 1st Floor, Micheal Palya, 80ft Road, Indiranagar, Bangalore-560038
          </p>
        </div>

        {/* --- 3. REFUND & RETURN POLICY --- */}
        <div id="refunds" className="infoSection">
          <h2>Refund & Return Policy</h2>
          <p><strong>Effective Date: 01/03/2025</strong></p>
          <p>
            We strive to provide absolute transparency via our standardized grading framework (A+ to C). Review our protection and return terms carefully.
          </p>
          <h3>1. Marketplace Escrow Logic (Channel 2)</h3>
          <p>
            Buyer payments for individual golfer listings are held safely by ClubLoop. The buyer has a 5-day window upon delivery arrival to confirm product accuracy or raise an official dispute to freeze payouts. If no dispute is raised within 5 days, funds automatically release to the seller's account minus our 10% platform commission.
          </p>
          <h3>2. Eligibility for Returns & Damaged Shipments</h3>
          <p>
            For applicable returns, items must be completely unused, unaltered, and retained inside their original packaging with original tags intact. If an item arrives structurally damaged or doesn't match its declared grade tag, you must contact <strong>return@clubloop.in</strong> within 48 hours of delivery with clear photographic proof to process a zero-cost replacement or full refund.
          </p>
          <h3>3. Processing Timelines</h3>
          <p>
            Approved refunds are auto-credited back to the user's original source payment route within 7-10 business days. Order cancellations are strictly restricted to a 24-hour window from payment completion, provided shipping workflows haven't been initiated by the seller or warehouse team.
          </p>
        </div>

        {/* --- 4. SHIPPING POLICY --- */}
        <div id="shipping" className="infoSection">
          <h2>Shipping & Delivery Policy</h2>
          <p><strong>Effective Date: 01/03/2025</strong></p>
          <p>
            ClubLoop coordinates logistics inside all serviceable major cities, remote towns, and rural pin codes across India. International shipping operations are currently unavailable.
          </p>
          <h3>1. Handling & Processing Window</h3>
          <p>
            <strong>Standard Stock:</strong> Dispatched within 1-2 business days (Monday to Saturday, excluding public holidays) following clear payment gateway confirmation.<br />
            <strong>P2P Marketplace:</strong> Individual sellers are required to securely pack and dispatch items via tracking courier services within 48 hours of a confirmed sale notification.
          </p>
          <h3>2. Delivery Timelines & Charges</h3>
          <p>
            • Metro Cities (Bangalore, Mumbai, Delhi, Chennai, Kolkata, Hyderabad): 2-4 business days.<br />
            • Major Towns & Serviceable Regions: 3-5 business days.<br />
            • Remote Areas: 5-7 business days.<br />
            <strong>Shipping Fee Model:</strong> Free standard delivery is automatically credited on order choices valued above ₹2,999. Orders falling below ₹2,999 incur a localized variable shipping charge ranging between ₹99 and ₹149, fully displayed at checkout.
          </p>
          <h3>3. Delivery Contingencies</h3>
          <p>
            Our courier networks perform up to 3 explicit delivery attempts. If an delivery path fails due to an incorrect address, recipient unavailability, or package refusal, the gear returns to our central point and the client might be billed for supplementary return transit overheads.
          </p>
        </div>

        {/* --- FOOTER TRACE LINK --- */}
        <div className="infoSection">
          <p>
            Have direct questions regarding your compliance rights, escrow protections, or logistics routing? Please{' '}
            <Link to="/contact" className="infoLink">
              contact our support desk
            </Link>
            . Alternatively, you can drop inquiries directly to <strong>help@clubloop.in</strong> or call support at <strong>+91 8880634721</strong>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LegalPrivacy;
